<template>
  <div id='LoginAtrust'>
    <img :src="imgBack" class="imgbackground"/>

    <div class="login-content">

      <div class="logo-top">
        <div class="logo-box">
          <img class="logo" :src="imgLogo" />
          <span class="logoTitle">{{$t('users.login.resourceManagement')}}</span>
        </div>
      </div>

      <div class="login-tab">
        <ul class="login-activeTab">
          <li
            v-for="item in activeTab"
            :class="{ active: active === item.dictValue }"
            :key="item.dictValue"
          >
            {{ item.dictLabel }}
          </li>
        </ul>
      </div>

      <div class="login-form">
        <el-form :model="loginForm" ref="LoginFormRef"
                 :rules="loginFormRules" v-show="active === '0'">
          <el-form-item prop="language">
            <el-select v-model="loginForm.language" popper-class="el-select" :popper-append-to-body="false" disabled>
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-globe fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
              <el-option
                v-for="item in languageList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" id="username" :placeholder="$t('users.login.pleaseinputusername')" disabled>
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-user fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="loginForm.password" id="password" :placeholder="$t('users.login.pleaseinputpassword')" disabled>
              <div slot="prefix" class="inprefix">
                <span style="color: black">
                  <i class="fa fa-lock fa-lg"></i>
                </span>
                <span style="padding-left: 15px;">|</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item>
            <span style="float: right;padding-right: 4px" @click="resetLoginForm">
              <el-button type="text" class="el-icon-refresh-right" disabled>{{$t('users.login.resetAccountPassword')}}</el-button>
            </span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-btn" @click="login" disabled>{{$t('users.login.login')}}</el-button>
          </el-form-item>
        </el-form>
        <el-form v-show="active === '1'" style="text-align: center">
          <div id="login_container"></div>
        </el-form>
      </div>
    </div>

    <div class="login-bottom">
      <el-button type="text" disabled>Copyright © 2023-2025 迈思普电子股份有限公司 版权所有</el-button>
      <el-button type="text" disabled>粤ICP备18058470号-1</el-button>
    </div>
  </div>
</template>

<script>
import i18n from '../../i18n'
import { mapMutations } from 'vuex'

export default {
  inject: ['reload'],
  name: 'LoginAtrust',
  created () {
    if (this.$route.query.code) {
      this.login(this.$route.query.code)
    } else {
      this.loadAuth2ssoLogin()
    }
  },
  mounted () {
    this.loadExplorer()
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return {
      explorer: 0,
      paraStr: '',
      imgBack: require('../../assets/photo/loginback.png'),
      imgLogo: require('../../assets/photo/loginlogo.png'),
      loginForm: {
        language: '',
        username: '',
        password: ''
      },
      languageList: [
        {
          value: 'en',
          label: i18n.t('users.lang.en')
        },
        {
          value: 'zh_CN',
          label: i18n.t('users.lang.zh_CN')
        },
        {
          value: 'zh_TW',
          label: i18n.t('users.lang.zh_TW')
        }
      ],
      loginFormRules: {},
      active: '0',
      activeTab: [
        { dictValue: '0', dictLabel: i18n.t('users.login.accountLogin') },
        { dictValue: '1', dictLabel: i18n.t('users.login.scanCodeLogin') }
      ]
    }
  },
  components: {},
  methods: {
    ...mapMutations('cacheTabs', ['setPage']),
    loadAuth2ssoLogin: async function () {
      const appid = '007ceb50-92b4-11ef-95f3-c13fbe91724f'
      const redirectUrl = 'http://mspdz.com:8071/%23/ag'
      window.location.href = 'https://120.86.65.249:8443/passport/v1/public/auth2ssoLogin?appid=' + appid + '&redirectUrl=' + redirectUrl + '&responseType=code&state='
    },
    loadGetUserInfoByCode: async function (codeVal) {
      const { data: res } = await this.$http.get('/users/getUserInfoByCode?code=' + codeVal)
      if (res.code === 0) {
        return this.$alert(res, '提示', {
          confirmButtonText: '确认'
        })
      } else {
        const message = res.message || '访问失败'
        return this.$alert(message, '提示', {
          confirmButtonText: '确认'
        })
      }
    },
    login: async function (codeVal) {
      // 发送请求进行登录
      const formData = new FormData()
      formData.append('code', codeVal)
      const { data: res } = await this.$http.post('/users/loginAtrust', formData)
      if (res.meta.status !== 200) {
        return this.$message.error(i18n.t('users.login.loginfailed') + res.meta.msg) // console.log("登录失败:"+res.meta.msg)
      }

      if (res.data.userStatus) {
        if (res.data.userStatus !== 'A') {
          return this.$message.error(i18n.t('users.login.userstatusnotvalid'))
        }
        if (res.data.userGroup === 'MSP') {
          this.setPage('HomePage')
        } else if (res.data.userGroup === 'VEND') {
          this.setPage('ScmHomePage')
          if (res.data.userCheck) {
            return this.$message.error('未获取当前应用权限')
          }
        } else {
          return this.$message.error('当前账号未获取应用权限')
        }
        window.sessionStorage.setItem('token', res.data.token)
        window.sessionStorage.setItem('currentSite', res.data.userDefSite)
        window.sessionStorage.setItem('currentHrSite', res.data.userDefHrSite)
        window.sessionStorage.setItem('currentEamSite', res.data.userDefEamSite)
        window.sessionStorage.setItem('defApp', res.data.userDefApplication)
        window.sessionStorage.setItem('currentUserCode', res.data.userCode)
        window.sessionStorage.setItem('currentUserName', res.data.userName)
        window.sessionStorage.setItem('currentUserDept', res.data.userDept)
        window.sessionStorage.setItem('currentUserDeptName', res.data.userDeptName)
        window.sessionStorage.setItem('currentUserEmp', res.data.userEmp)
        window.sessionStorage.setItem('currentUserWx', res.data.userOpenid)
        window.sessionStorage.setItem('currentUserVend', res.data.userVend)
        window.sessionStorage.setItem('currentUserTel', res.data.userTel)
        window.sessionStorage.setItem('currentUserPswType', res.data.userPswType)
        const moment = require('moment')
        const userPswDate = moment(res.data.userPswDate).format('YYYY-MM-DD')
        window.sessionStorage.setItem('currentUserPswDate', userPswDate)
        window.sessionStorage.setItem('currentUserGroup', res.data.userGroup)
        window.sessionStorage.setItem('currentUserEmail', res.data.userEmail)
        const userInfoDate = moment(res.data.userInfoDate).format('YYYY-MM-DD')
        window.sessionStorage.setItem('currentUserInfoDate', userInfoDate)
        if (res.data.userAdm) {
          window.sessionStorage.setItem('userAdm', res.data.userAdm)
        } else {
          window.sessionStorage.setItem('userAdm', '')
        }
        localStorage.setItem('lang', process.env.VUE_APP_I18N_LOCALE)
        this.$router.push('/main')
      } else {
        const message = res.data.message || '访问失败'
        return this.$alert(message, '提示', {
          confirmButtonText: '确认'
        })
      }
    },
    loadExplorer () {
      const that = this
      const agent = navigator.userAgent.toLowerCase()
      const regFf = /firefox\/[\d.]+/gi
      const regChrome = /chrome\/[\d.]+/gi
      const regSaf = /safari\/[\d.]+/gi
      //  firefox
      if (agent.indexOf('firefox') > 0) {
        const firefox = parseInt(agent.match(regFf)[0].slice(8, 10))
        if (firefox >= 54) {
          that.explorer = 1
        }
      }
      //  Chrome
      if (agent.indexOf('chrome') > 0) {
        const chrome = parseInt(agent.match(regChrome)[0].slice(7, 9))
        const chrome2 = parseInt(agent.match(regChrome)[0].slice(7, 10))
        if ((chrome >= 58) || (chrome2 >= 100)) {
          that.explorer = 1
        }
      }
      //  Safari
      if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
        const safari = parseInt(agent.match(regSaf)[0].slice(7, 10))
        if (safari >= 537) {
          that.explorer = 1
        }
      }
      if (that.explorer === 0) {
        that.$message({
          showClose: true,
          type: 'warning',
          message: i18n.t('users.login.browserVersionLower')
        })
      } else {
        return {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
#LoginAtrust {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  background-size: cover;
  min-height: 570px;

  .imgbackground {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
  }
  .login-content {
    z-index: 99;
    position: absolute;
    right: 10%;
    min-width: 360px;
    min-height: 490px;
    width: 20%;
    height: 55%;
    border-radius: 14px;
    padding: 40px;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    background: linear-gradient(
      rgba(231, 231, 241, 0.5),
      rgba(255, 255, 255, 1)
    );

    .logo-top {
      .logo-box {
        display: flex;
        opacity: 1;
        .logo {
          width: 50px;
          height: 50px;
        }
        .logoTitle {
          height: 50px;
          line-height: 50px;
          font-size: 30px;
          font-weight: bolder;
          padding-left: 15px;
        }
      }
    }

    .login-tab {
      width: 100%;
      padding-bottom: 5px;

      .login-activeTab {
        display: flex;
        margin: 40px 0 40px;
        padding-left: 0px;
        li {
          font-size: 20px;
          line-height: 28px;
          color: #9f9f9f;
          cursor: pointer;
          transition: all 0.5s;
          margin: 0 40px 0 0;
          list-style-type: none;
        }
        li.active {
          font-size: 20px;
          font-weight: bold;
          color: #282828;
          opacity: 1;
          position: relative;
          list-style-type: none;
        }
      }

    }

    .login-form{

      .inprefix {
        min-height: 40px;
        width: 30px;
        font-size: 18px;
        padding-left: 15px;
        display: flex;
        justify-content: center;
        align-items: center
      }

      .el-select {
        ::v-deep .el-select-dropdown {
          .el-select-dropdown__item {
            font-size: 13px;
            line-height: 34px;
            height: 35px;
          }
        }

      }

      /deep/.el-form-item {
        margin-bottom: 30px;
      }

      /deep/.el-input__inner {
        padding-left: 70px;
        min-height: 40px;
        font-size: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .login-btn {
        width: 100%;
        padding: 15px;
        font-size: 22px;
        color: #ffffff;
        background: #5AAFFF;
      }
    }
  }

  .login-bottom {
    position: absolute;
    bottom: 10px;
    right: 10%;
    min-width: 360px;
    width: 20%;
    height: 80px;
    padding: 0px 40px;
    text-align: center
  }
}
</style>
